//Angular References
import { NgModule, Component } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

//Route Guard Services
import { CanDeactivateGuard } from './shared/can-deactivate-guard.service';

//Components
import { PageNotFoundComponent } from './UI/shared/page-not-found/page-not-found.component';
import { MissingCredentialsComponent } from './UI/shared/missing-credentials/missing-credentials.component';
import { AccessDeniedComponent } from './UI/shared/access-denied/access-denied.component';
import { RoiDocumentComponent } from './UI/contract-wizard/roi-document/roi-document.component';
import { ThankyouComponent } from './UI/contract-wizard/thankyou/thankyou.component';
import { ContractListComponent } from './UI/contract-wizard/contract-list/contract-list.component';
import { ContractComponent } from './UI/contract-wizard/contract/contract.component';
import { ContractConfigComponent } from './UI/contract-wizard/contract-config/contract-config.component';
import { ContractRemoteComponent } from './UI/contract-wizard/contractRemote/contractRemote.component';
import { ClientRemoteComponent } from './UI/contract-wizard/client-remote/client-remote.component';
import { DocumentExportComponent } from './UI/document-export/document-export.component';
import { ConnectClientComponent } from './UI/contract-wizard/connect-client/connect-client.component';
import { ClientExportToPdfComponent } from './UI/client-export-to-pdf/client-export-to-pdf.component';
import { CustContractComponent } from './UI/cust-contract/cust-contract.component';
import { CorpContractComponent } from './UI/corp-contract/corp-contract.component';
import { ContractSignatureListComponent } from './UI/contract-signature-list/contract-signature-list.component';
import { ContractListenerComponent } from './UI/contract-wizard/contract-listener/contract-listener.component';
import { PatentPlusContractListComponent } from './UI/patent-plus-contract-wizard/patent-plus-contract-list/patent-plus-contract-list.component';
import { PatentPlusContractComponent } from './UI/patent-plus-contract-wizard/patent-plus-contract/patent-plus-contract.component';
import { PatentPlusClientRemoteComponent } from './UI/patent-plus-contract-wizard/patent-plus-client-remote/patent-plus-client-remote.component';
import { PatentPlusContractRemoteComponent } from './UI/patent-plus-contract-wizard/patent-plus-contract-remote/patent-plus-contract-remote.component';
import { AllocatedFileNumbersListComponent } from './UI/allocated-file-numbers-list/allocated-file-numbers-list.component';

//Routes
const appRoutes: Routes = [
    {
        path: 'notfound',
        component: PageNotFoundComponent
    },
    {
        path: 'unauthorized',
        component: MissingCredentialsComponent
    },
    {
        path: 'access-denied',
        component: AccessDeniedComponent
    },
    {
        path: '',
        redirectTo: 'access-denied',
        pathMatch: 'full'
    },
    {
        path: 'roi-document/:contact/:invention/:contractSessionId/:clpUserId/:patentId',
        component: RoiDocumentComponent,
        canDeactivate: [CanDeactivateGuard]
    },
    {
        path: 'thankyou/:invention/:productId',
        component: ThankyouComponent,
        canDeactivate: [CanDeactivateGuard]
    },
    {
        path: 'contract-list/:clpuserid/:contact',
        component: ContractListComponent,
        canDeactivate: [CanDeactivateGuard]
    },
    {
        path: 'patent-plus-contract-list/:clpuserid/:contact',
        component: PatentPlusContractListComponent,
        canDeactivate: [CanDeactivateGuard]
    },
    {
        path: 'contract/:contact/:invention/:contractSessionId/:rdClpUserId',
        component: ContractComponent,
        canDeactivate: [CanDeactivateGuard]
    },
    {
        path: 'patent-plus-contract/:contact/:invention/:contractSessionId/:rdClpUserId',
        component: PatentPlusContractComponent,
        canDeactivate: [CanDeactivateGuard]
    },
    {
        path: 'contract-remote/:contact/:invention/:contractSessionId/:rdClpUserId',
        component: ContractRemoteComponent,
        canDeactivate: [CanDeactivateGuard]
    },
    {
        path: 'patent-plus-contract-remote/:contact/:invention/:contractSessionId/:rdClpUserId',
        component: PatentPlusContractRemoteComponent,
        canDeactivate: [CanDeactivateGuard]
    },
    {
        path: 'client-remote/:contact/:invention/:contractSessionId',
        component: ClientRemoteComponent,
        canDeactivate: [CanDeactivateGuard]
    },
    {
        path: 'patent-plus-client-remote/:contact/:invention/:contractSessionId',
        component: PatentPlusClientRemoteComponent,
        canDeactivate: [CanDeactivateGuard]
    },
    {
        path: 'contractlistener/:contactId',
        component: ContractListenerComponent,
        canDeactivate: [CanDeactivateGuard]
    },
    {
        path: 'contract-config/:clpuserid/:patentId',
        component: ContractConfigComponent,
        canDeactivate: [CanDeactivateGuard]
    },
    {
        path: 'document-export',
        component: DocumentExportComponent,
        canDeactivate: [CanDeactivateGuard]
    },
    {
        path: 'cust-contract/:contact/:contractSessionId',
        component: CustContractComponent,
        canDeactivate: [CanDeactivateGuard]
    },
    {
        path: 'corp-contract/:contact/:contractSessionId',
        component: CorpContractComponent,
        canDeactivate: [CanDeactivateGuard]
    },
    {
        path: 'clientLink/:urlid',
        component: ConnectClientComponent,
        canDeactivate: [CanDeactivateGuard]
    },
    {
        path: 'client-export-to-pdf',
        component: ClientExportToPdfComponent,
        canDeactivate: [CanDeactivateGuard]
    },
    {
        path: 'contract-signature-list',
        component: ContractSignatureListComponent,
        canDeactivate: [CanDeactivateGuard]
    },
    {
        path: 'file-numbers-list/:clpuserid/:patentId/:rId',
        component: AllocatedFileNumbersListComponent,
        canDeactivate: [CanDeactivateGuard]
    },
    {
        path: '**',
        component: PageNotFoundComponent
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, { enableTracing: false })
    ],
    exports: [
        RouterModule
    ],
    providers: [
        CanDeactivateGuard
    ]
})
export class AppRoutingModule { }
